export default new URL("../images/testimonial.jpg", import.meta.url).href;